import HeaderSignature from "../../../common/components/vue/HeaderSignature.vue";
const app = new Vue({
    el: "#category",
    components: {
        HeaderSignature
    },
    data() {
        return {
            themePageDTO: themePageDTO,
            isTabHome: true,
            themeIds: [],
            selectedTheme: undefined
        };
    },
    mounted() {
        this.themeIds = this.themePageDTO.themes.map(item => item.id);
        window.addEventListener("hashchange", this.filter);
        this.filter();
        document.addEventListener("DOMContentLoaded", () => {
            this.applyActiveToSelectedTheme();
        });

        // a workaround to have the clicks on page menu items working again since new release ob1.
        document.querySelectorAll(".ob1-menu-page a").forEach(
            (button) => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    const menuItem = button.hash.startsWith("#") ? button.hash.substring(1) : button.hash;
                    this.filter(menuItem);
                });
            }
        );
    },
    watch: {
        selectedTheme() {
            this.applyActiveToSelectedTheme();
        }
    },
    methods: {
        callTMS(tmsDTO) {
            Tms.link({
                category: tmsDTO.tagZone,
                action: tmsDTO.tagName,
                label: tmsDTO.tagTarget
            });
        },
        getLength(index, length) {
            return this.isTabHome ? index < 3 : length;
        },
        showBtnShowAll(size) {
            return this.isTabHome && size > 3;
        },
        filter(menuItem) {
            if (this.themeIds.includes(menuItem) && menuItem !== "home" && menuItem !== "" && menuItem !== undefined) {
                this.selectedTheme = menuItem;
            } else {
                if (menuItem === "home") {
                    this.selectedTheme = menuItem;
                } else {
                    this.selectedTheme = this.readHash();
                }
            }

            const themeExists = this.themeIds.includes(this.selectedTheme);

            if (!themeExists) {
                this.selectedTheme = "home";
            }

            this.themePageDTO.themes.forEach((theme) =>
                theme.showDetails = !themeExists || theme.id === this.selectedTheme
            );

            this.isTabHome = this.selectedTheme === "home" || this.selectedTheme === "";

            if (!themeExists) {
                this.cleanInvalidHash();
            }
        },
        cleanInvalidHash() {
            const loc = window.location;
            window.history.replaceState("", "", loc.origin + loc.pathname + loc.search);
        },
        readHash() {
            const hash = window.location.hash;
            return hash.startsWith("#") ? hash.substring(1) : hash;
        },
        applyActiveToSelectedTheme() {
            let activeElement = document.querySelector(".ob1-menu-page .active");
            if (activeElement) {
                activeElement.classList.remove("active");
            }
            let themes = document.querySelector("a[href='#" + this.selectedTheme + "']");
            if (themes) {
                themes.parentNode.classList.add("active");
            }
            //tms
            let selectedTheme = this.themePageDTO.themes.find(theme => theme.id === this.selectedTheme);
            if (selectedTheme) {
                let tmsDTO = selectedTheme.btnShowAll.tmsDTO;
                Tms.link({
                    category: tmsDTO.tagZone,
                    action: tmsDTO.tagName,
                    label: tmsDTO.tagTarget
                });
            }
        }
    }
});

window.onhashchange = app.filter;
